import { apiClient } from './apiClient';

class AdminService {
  /**
   * Corrige un valor de una tabla de baremos (solo admin). Actualiza la fila en la
   * DB y regenera el archivo de migración correspondiente para que el fix quede
   * permanente en despliegues futuros desde cero.
   */
  async updateNormRow(
    tableKey: string,
    id: number,
    fields: Record<string, string | number | null>,
  ): Promise<any> {
    const response = await apiClient.patch(`/admin/norms/${tableKey}/${id}`, fields);
    return response.data?.data;
  }
}

export default new AdminService();
